const STATUS_LABELS = {
  open: 'Moved to open',
  remediation_claimed: 'Remediation claimed',
  verified: 'Remediation verified',
  accepted_risk: 'Risk accepted',
  reopened: 'Reopened',
  possibly_remediated: 'Possibly remediated',
  suppressed: 'Hidden',
};

const STATUS_COLORS = {
  open: 'red',
  remediation_claimed: 'amb',
  verified: 'grn',
  accepted_risk: 'gry',
  reopened: 'red',
  possibly_remediated: 'grn',
  suppressed: 'amb',
};

const API_STATUS = {
  0: 'open',
  1: 'remediation_claimed',
  2: 'verified',
  3: 'accepted_risk',
  4: 'reopened',
  5: 'possibly_remediated',
};

function toArray(data) {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object') {
    for (const key of ['items', 'history', 'events', 'results', 'data']) {
      if (Array.isArray(data[key])) return data[key];
    }
  }
  return [];
}

function normalizeStatus(value) {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'number') return API_STATUS[value] ?? String(value);
  const raw = String(value).trim();
  if (/^\d+$/.test(raw)) return API_STATUS[Number(raw)] ?? raw;
  return raw
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase();
}

function firstValue(...values) {
  return values.find(value => value !== undefined && value !== null && value !== '');
}

function toDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function normalizeFindingStatusHistory(data) {
  return toArray(data)
    .map((entry, index) => {
      if (!entry || typeof entry !== 'object') return null;
      const status = normalizeStatus(firstValue(entry.toStatus, entry.status, entry.Status, entry.newStatus));
      const changedAt = firstValue(entry.changedAt, entry.createdAt, entry.timestamp, entry.at, entry.date);
      const changedBy = firstValue(entry.changedByName, entry.changedBy, entry.actorName, entry.actor, entry.userName, entry.user);
      const note = firstValue(entry.note, entry.comment, entry.reason, entry.message);
      return {
        id: firstValue(entry.id, entry.historyId, `${status || 'status'}-${changedAt || index}`),
        status,
        changedAt,
        changedBy,
        note,
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      const at = a.changedAt ? new Date(a.changedAt).getTime() : 0;
      const bt = b.changedAt ? new Date(b.changedAt).getTime() : 0;
      return at - bt;
    });
}

export function statusHistoryTimeline(history, finding, colors) {
  const detectedAt = finding?.age ?? finding?.firstSeenAt ?? finding?.createdAt ?? null;
  const rows = [];
  const detectedDate = toDate(detectedAt);
  if (detectedDate) {
    rows.push({ key: 'detected', l: 'Finding detected', t: detectedDate, dot: colors.t2 });
  }

  for (const event of history) {
    const label = STATUS_LABELS[event.status] ?? `Status changed to ${event.status || 'unknown'}`;
    const actor = event.changedBy ? ` by ${event.changedBy}` : '';
    const colorKey = STATUS_COLORS[event.status] ?? 't2';
    rows.push({
      key: event.id,
      l: `${label}${actor}`,
      note: event.note,
      t: toDate(event.changedAt),
      dot: colors[colorKey] ?? colors.t2,
    });
  }

  return rows;
}
